﻿export function artWorkApprovalShowHide() {
    document.addEventListener("change", function (e) {
        if (e.target.id === "ApproveReject") {
            showHideFeedback();
        }
    })
}

function showHideFeedback(event) {
    let dropdown = document.querySelector('#ApproveReject');
    let feedbackDiv = document.querySelector('[data-feedback]');
    if (dropdown) {
        let value = dropdown.value;
        if (value === 'False') {
            feedbackDiv.style.display = 'block';
        } else {
            feedbackDiv.style.display = 'none';
        }
    } else {
        feedbackDiv.style.display = 'none';
    }
}